import type { ReactNode } from "react";

interface SettingCardProps {
  title?: string;
  description?: string;
  children: ReactNode;
}

export const SettingCard = ({ title, description, children }: SettingCardProps) => (
  <div className="bg-white rounded-lg shadow-md p-4">
    {title && <h2 className={`text-lg font-bold text-gray-900 ${description ? "mb-1" : "mb-2"}`}>{title}</h2>}
    {description && <p className="text-sm text-gray-500 mb-2">{description}</p>}
    {children}
  </div>
);
